import { useEffect } from 'react';
import { selectCurrentUser, selectIsAuthenticated } from '../../components/auth/authSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../stores/store.ts';
import Echo from 'laravel-echo';

export interface IPrivateChannelArgs {
    privateChannel: ReturnType<Echo<'pusher'>['private']>;
    dispatch: ReturnType<typeof useAppDispatch>;
}

interface IWrapperProps {
    echo: Echo<'pusher'> | null;
    // Callback, który otrzyma gotowy kanał i dispatch do rejestracji dowolnych eventów
    registerListeners: (args: IPrivateChannelArgs) => void;
}

export const useUserPrivateChannel = ({ echo, registerListeners }: IWrapperProps) => {
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const currentUser = useAppSelector(selectCurrentUser);
    const _dispatch = useAppDispatch();

    useEffect(() => {
        if (!echo || !isAuthenticated || !currentUser) return;

        const channelName = `App.Models.User.${currentUser.id}`;
        const privateChannel = echo.private(channelName);

        // Uruchamiamy rejestrację specyficznych listenerów przekazanych z zewnątrz
        registerListeners({ privateChannel, dispatch: _dispatch });

        return () => {
            // Sprzątamy cały kanał przy unmouncie lub zmianie user/auth
            echo.leave(channelName);
        };
    }, [isAuthenticated, currentUser, echo, _dispatch, registerListeners]);
};